const $ = require('jquery');
const backstretch = require('jquery.backstretch');
const hammerjs = require('hammerjs');
const fancybox = require("@fancyapps/fancybox");

// WOWJS
const WOW = require('wowjs');
window.wow = new WOW.WOW({
    live: false
});
window.wow.init();

// FastClick
const FastClick = require('fastclick');
FastClick.attach(document.body);


$(function () {

	/* @ global vars */
    XSWidthMin = 0;
    XSWidthMax = 359;
    SWidthMin = 360;
    SWidthMax = 767;
    MWidthMin = 768;
    MWidthMax = 989;
    LWidthMin = 990;
    LWidthMax = 1199;
    XLWidthMin = 1200;
    currentWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    currentWindowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	


	/*
	  	-- @ COOKIES @ --
	  	* Hide cookies block when "J'accepte" button is clicked
	*/
	$(document).on('click', '#cookies a.js-accept-cookie', function (e) {
		var d = new Date();
		d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toGMTString();
		document.cookie = "_ck=b326b5062b2f0e69046810717534cb09; " + expires + ";path=/";

		$(this).parent().fadeOut('fast', function(e){
			$(this).remove();
		});
	});



    /*
        -- @ FASTCLICK @ --
    */
    



	/*
	-- @ LINKS @ --
	*/
	// External links
	$(document).on('click', 'a[href$=".pdf"], a.external-link', function(e) {
		e.preventDefault()
		window.open($(this).attr("href"))
	})
	// Disabled links
	$(document).on('click', 'a.noLink, a[href="GOTOLINK"]', function(e) {
		e.preventDefault()
	})
	// Backtotop links
	$(document).on('click', 'a.backtotop', function(e) {
		e.preventDefault()
		$('body,html').animate({scrollTop: 0}, 250, 'swing');
	})



	/*!
        -- @ Modals @ --
    */
    /* Open modal */
    $(document).on('click', '.js-modal-open', function (e) {
        e.preventDefault();

        var modal = $(this).data('target');
        var selector = '#' + modal;

        if ($(selector).length) {
            $('html,body').addClass('opened-modal');
            $(selector).addClass('active');

            // show hidden text into the modal
            if ($(this).data('texttoshowinmodal')) {
                var klass = $(this).data('texttoshowinmodal');
                $(selector).find('' + klass + '').addClass('shown')
            }

            $(selector).trigger('cc.modal.open');
        } else {
            alert('ChuckCSS error : modal with attribute id="' + modal + '" does not exist!');
        }
    });
    /* Close modal */
    $('.modal:not([data-disabled-overlay])')
        .find('.modal-overlay')
        .add('.modal *[data-close-modal]')
        .on('click', function (e) {
            e.preventDefault();

            if ($(this).parents('.modal').hasClass('active'))
                $(this).parents('.modal').removeClass('active');

            if (!$('.modal.active').length)
                $('html,body').removeClass('opened-modal');

            // $(this).parents('.modal').trigger('cc.modal.close');
        });
    /* Close modal Event */
	$('.modal').on('cc.modal.close', function() {
		alert('modal closed')
	});



	/*
        -- @ BACKSTRETCH @ --
        * Attach responsive background-images to elements
    */
    $('.backstretch').each(function (i, el) {
        var imgName = $(this).attr('data-img');

        if (typeof imgName !== 'undefined' && imgName.length)
            $(this).backstretch(imgName);
    });



    /*
        -- @ MAIN MENU PHONE @ --
        * Show the hamburger button for main menu on phones
    */
    var _closeMenus = function() {
        $('html, body').removeClass('opened-menu')
        // Remove "shown" class to all menus
        $('#main-header nav').removeClass('shown')
        // Remove "is-active" class to all hamburger buttons
        $('.js-open-menu button').removeClass('is-active')
    }
    var _openMenu = function(menu, button) {
        $('html, body').addClass('opened-menu')
        menu.addClass('shown')
        button.addClass('is-active')
        
    }

    // Main menu, if exists
    if($('#js-nav-bottom-header').length) {
        // Swipe left to close menus
        var navBottomHeader = document.getElementById('js-nav-bottom-header');
        var hammerBottomMenu = new Hammer(navBottomHeader);

        hammerBottomMenu.on('swipeleft', function(ev) {
            _closeMenus();
        });


        // Swipe Right on section logo = open main menu
        var sectionLogo = document.getElementById('bottom-header');    
        var hammerSectionLogo = new Hammer(sectionLogo);

        hammerSectionLogo.on('swiperight', function(ev) {
            _openMenu($('#bottom-header nav'), $('#bottom-header .js-open-menu button'));
        });
    }

    // Top menu, if exists
    if($('#js-nav-top-header').length) {
        // Swipe left to close menus
        var navTopHeader = document.getElementById('js-nav-top-header');
        var hammerTopMenu = new Hammer(navTopHeader);

        hammerTopMenu.on('swipeleft', function(ev) {
            _closeMenus();
        });

        // Swipe Right on section logo = open main menu
        var sectionTopHeader = document.getElementById('top-header');    
        var hammerSectionTopHeader = new Hammer(sectionTopHeader);

        hammerSectionTopHeader.on('swiperight', function(ev) {
            _openMenu($('#js-nav-top-header'), $('#top-header .js-open-menu button'));
        });
    }

    // Swiperight on logo to open main menu
    if($('#logo').length) {
        var logo = document.getElementById('logo');    
        var hammerLogo = new Hammer(logo);

        // Swipe Right on logo = open main menu
        hammerLogo.on('swiperight', function(ev) {
            _openMenu($('#bottom-header nav'), $('#bottom-header .js-open-menu button'));
        });
    }

    // Click on Hamburger
    $(document).on('click','.js-open-menu button', function (e) {
        e.preventDefault()

        var $menu = $(this).parent().next()

        if(!$menu.is('nav')) {
            alert('<nav> element must be placed just after the hamburger (msg from app.js)')
            return;
        }

        if ($(this).hasClass('is-active')) {
            _closeMenus();
        } else {
            _openMenu($menu, $(this));
        }
    });



    /*
     -- @ FANCYBOX PLUGIN @ --
        * Used in:
            - Homepages (news)
    */
    $("[data-fancybox]").fancybox({
        protect: true // No click right
    });
});


// WEBPACK FOOTER //
// ./assets/js/app.js